import React from 'react'
import '../Component/css/Green.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/green/header.webp'
import header2 from '../assets/product/green/header2.webp'
import header3 from '../assets/product/green/header3.webp'
import header5 from '../assets/product/green/header5.webp'
import timeline from '../assets/product/green/timeline.webp'
import greenbg from '../assets/product/green/greenbg.webp'

// video
import greenVideo from '../assets/product/green/green.mp4'



const Green = () => {

  const navigate = useNavigate()

  return (
    <div className="about">
      <section className="about-section sec-padding">
        <div className="container">
          <h1 className='projecth1'>Product.</h1>
          <div className="project-row">
          <div className='green-project'>
{/* IMAGE BACKGROUND */}
          <img src={greenbg} alt="background" className='treebg' />

{/* TIMELINE */}
<div className="green-timeline">
                  <ul className='green-ul'>
                    <li className='green-li'><div className="li">Challenge</div><span>The website needs to be designed to better connect homeowners or housing agents with potential customers, including building a more intuitive information architecture where clients can negotiate the price directly with homeowners or housing agent</span></li>
                    {/* <li className='green-li'><div className="li">Role</div><span> Product Design and UX Research</span></li> */}
                    <li className='green-li'><div className="li">Sector</div><span>Real Estate | Business</span></li>
                    <li className='green-li'><div className="li">Timeline</div><span>2 Months</span></li>
                  </ul>
                </div>

                

{/* HEADER 1 */}
            <div className="green-header-body">
              <div className="green-header-detail">
                <div className="green-header-text-one">
                  <div className="green-main-text-one">
                    <h3>About</h3>
                    <div className="green-icon">
                    <i class="fas fa-desktop"></i>
                    <i class="fas fa-laptop"></i>
                    <i class="fas fa-tablet"></i>
                    </div>
                  </div>  
                    <p>
                    A real estate application designed to assist people to find residential spaces to buy or rent. The goal of the project was to design a real estate web application that combines an easy user experience with a simple user interface, allowing users to have a stress-free experience buying and renting out residential spaces. Greenfield gives its users the option to buy or rent houses tailored to their requirements. The prototype is avaliable on <strong><a href="https://www.figma.com/proto/ezctzrNN5XSYvnDdavWXFG/Real-estate-Web-Page?page-id=0%3A1&node-id=1%3A2&starting-point-node-id=1%3A2" target="_blank" rel="noopener noreferrer">Figma</a></strong>
                    </p>             
                </div>
              </div>
            </div>
            <div className="green-header-image-one">
              <img src={header} alt="Green Header" />
            </div>
{/* GOAL */}
        <div className="green-goal">
              <div className="green-goal-text">
                <h3>Goal</h3>
                <p>The aim was to design a real estate web application that combines an easy user experience with a simple user interface, allowing users to have a stress-free experience buying and renting residential spaces.</p>
              </div>
        </div>
        <div className="green-goal-image">
          <img src={header2} alt="Green Goal" />
        </div>
{/* DESIGN PROCESS */}
            <div className="green-detail">
              <div className="green-detail-text">
                <h3>Design Process</h3>
                <p>To begin, the research focused on the core functionality of a task management application to gain a thorough understanding of the project. Second, we created and organized a user flow diagram. Finally, I started with a low-fidelity wireframe and worked with <strong><a href="https://www.linkedin.com/in/kolawole-olagoke-435796153/" target="_blank"  rel="noopener noreferrer"> Kolawole Olagoke</a></strong>, a team member, on the next phase of the design.</p>
              </div>
            </div>
            <div className="green-detail-image">
                <img src={header3} alt="Green Detail" />
            </div>

{/* BUY AND RENT */}
            <div className="green-buy-and-rent">
              <div className="green-buy-and-rent-text">
                <h3>Buy and Rent page</h3>
                <p>To avoid overloading the UI, I designed the buy and rent page to be lightweight and user friendly. I decided to use filters to achieve an aesthetic and modern buy and rent page.</p>
              </div>

              <div className="green-buy-and-rent-image">
                <img src={header5} alt="Green Detail" />
              </div>
            </div>
{/* TIMELINE */}
            <div className="green-timeline-screen">
              <img src={timeline} alt="Green Time Screen" />
            </div>
{/* VIDEO */}
            <div className="tree-detail-image">
                <video src={greenVideo} controls></video>
            </div>

                  <h2 className='green-h2'><span>Thanks for scrolling</span></h2>

                  <p className='green-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
            </div>


{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                                <p>Go back to Portfolio</p> 
                                <div className="icon">
                                    <i class="fas fa-angle-right"></i>
                                    <i class="fas fa-angle-right"></i>
                                </div>
                    </div>
              </div>
            </div>    
          </section>
        </div>
  )
}

export default Green